<div class="row p-0">
	<div class="col-4 mt-3 ml-auto">
		<select id="locationFilter" class="ml-2 mt-2 form-control custom-location-select shadow-sm"
			[(ngModel)]="selectedLoc" (ngModelChange)="applyLocationFilter($event)">
			<option value="">All Locations</option>
			<option *ngFor="let loc of locations" [value]="loc.loccode">
				{{ loc.loccode }} - {{ loc.locationname }}
			</option>
		</select>
	</div>

	<div class="col-8 text-right ml-auto mr-0">
		<button class="btn btn-sm btn-success" (click)="exportXls()" [disabled]="exporting">
			<i *ngIf="!exporting" class="fa fa-file-excel-o"></i>
			<i *ngIf="exporting" class="fa fa-spinner fa-spin"></i>
		</button>
		&nbsp;&nbsp;
		<button class="btn btn-sm btn-danger" (click)="exportPdf()" [disabled]="exporting">
			<i *ngIf="!exporting" class="fa fa-file-pdf-o"></i>
			<i *ngIf="exporting" class="fa fa-spinner fa-spin"></i>
		</button>
	</div>
</div>

<div class="table" #print_table>
	<table class="mt-3 table table-hover table-striped">
		<thead class="sticky-top thead-dark">
			<tr>
				<th scope="col">#</th>
				<th scope="col">Loc#</th>
				<th scope="col">Location</th>
				<th scope="col">Item ID</th>
				<th scope="col">Description</th>
				<th scope="col">Quantity</th>
				<th scope="col" class="noprint">Actions</th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let item of filteredNegativeItems; let i = index">
				<tr *ngFor="let loc of item.locations; let j = index" [class.table-group-row]="j === 0">
					<th scope="row" *ngIf="j === 0" [attr.rowspan]="item.locations.length">{{ i + 1 }}</th>
					<td>{{ loc.loccode }}</td>
					<td>{{ loc.locationname }}</td>
					<td>{{ item.item }}</td>
					<td>{{ item.description }}</td>
					<td class="text-danger font-weight-bold">{{ loc.quantity }}</td>
					<td class="noprint">
						<a [routerLink]="'/inventory/view/' + item.item">View</a>
					</td>
				</tr>
			</ng-container>
		</tbody>
	</table>
</div>